const state = {
  // showThemePicker: false,
  menuBg: '#222834', // 菜单栏背景
  menuActiveBg: '#209e91', // 菜单栏选中背景
  color: '#c0c4cc', // 菜单栏字体颜色
  activeColor: '#ffffff' // 菜单栏字体选中颜色
}
const mutations = {
  SET_MENU_BG: (state, val) => {
    state.menuBg = val
  },
  SET_MENU_ACTIVE_BG: (state, val) => {
    state.menuActiveBg = val
  },
  SET_COLOR: (state, val) => {
    state.color = val
  },
  SET_ACTIVE_COLOR: (state, val) => {
    state.activeColor = val
  }
  // 侧边栏开关
  // TOGGLE_THEME_PICKER: state => {
  //   state.showThemePicker = !state.showThemePicker
  // }
}
const actions = {
  // toggleThemePicker({ commit }) {
  //   commit('TOGGLE_THEME_PICKER')
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
